import { DatasourceResource } from '@mode/legacy/data-access-model-js';
import { AppStore } from '~/types/main.types';

export class ConnectionService {
  static $inject = ['DataSourceModel', 'RxStoreService'];

  constructor(private DataSourceModel: any, private rxStoreService: AppStore) {}

  public getDatasource(token: string, account: string): Promise<DatasourceResource> {
    const params = {
      token,
      account,
      useEntryPath: true,
      includes: ['permissions', 'creator'],
      refresh: true,
    };

    return this.DataSourceModel.find(params);
  }
}
